import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import { UserMenu } from "../../fakeData/UserMenu";
import { clearAuth } from "../../utils/auth";
import { useTranslation } from "react-i18next";

const User = () => {
  const { t } = useTranslation();

  const handleLogout = () => {
    clearAuth();
    window.location.href = "/";
  };

  const LogoutIcon = () => (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      viewBox="0 0 512 512"
      height="1em"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="32"
        d="M336 112a80 80 0 00-160 0v96"
      ></path>
      <rect
        width="320"
        height="272"
        x="96"
        y="208"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="32"
        rx="48"
        ry="48"
      ></rect>
    </svg>
  );

  return (
    <div className="bg-gray-50 min-h-screen">
      <div className="mx-auto max-w-screen-2xl px-3 sm:px-10">
        <div className="py-4 lg:py-12 flex flex-col lg:flex-row w-full">
          {/* Desktop Sidebar Menu */}
          <div className="hidden lg:block flex-shrink-0 w-full lg:w-80 mr-7 lg:mr-10 xl:mr-10">
            <div className="bg-white p-4 sm:p-5 lg:p-8 rounded-md sticky top-32">
              {UserMenu.map((data, index) => (
                <NavLink
                  key={index}
                  to={data.path}
                  className={({ isActive }) =>
                    `group p-2 my-2 flex items-center rounded-md w-full hover:bg-gray-50 hover:no-underline focus:no-underline transition ${isActive
                      ? "text-emerald-600 bg-gray-50"
                      : "text-black"
                    }`
                  }
                >
                  <span className="mr-2 text-base">{data.icon}</span>

                  <span className="inline-flex items-center justify-between text-sm font-medium w-full">
                    {t(data.titleKey, data.title)}
                  </span>
                </NavLink>
              ))}

              <button
                type="button"
                onClick={handleLogout}
                className="p-2 my-2 flex items-center rounded-md hover:bg-gray-50 w-full text-black hover:text-emerald-600 transition"
              >
                <span className="mr-2 text-base">
                  <LogoutIcon />
                </span>

                <span className="inline-flex items-center justify-between text-sm font-medium w-full">
                  {t("dashboardMenu.logout", "Logout")}
                </span>
              </button>
            </div>
          </div>

          {/* Main Content Area */}
          <div className="w-full">
            {/* Mobile Top Menu */}
            <div className="lg:hidden mb-4 bg-white rounded-md border border-gray-100 p-3">
              <div className="grid grid-cols-2 gap-2">
                {UserMenu.map((data, index) => (
                  <NavLink
                    key={index}
                    to={data.path}
                    className={({ isActive }) =>
                      `px-3 py-3 rounded-md flex items-center gap-2 text-xs font-medium hover:no-underline focus:no-underline transition ${isActive
                        ? "bg-emerald-50 text-emerald-600"
                        : "bg-gray-50 text-gray-600 hover:text-emerald-600"
                      }`
                    }
                  >
                    <span className="text-lg shrink-0">{data.icon}</span>

                    <span className="leading-tight break-words">
                      {t(data.titleKey, data.title)}
                    </span>
                  </NavLink>
                ))}

                <button
                  type="button"
                  onClick={handleLogout}
                  className="col-span-2 px-3 py-3 rounded-md flex items-center justify-center gap-2 text-xs font-medium bg-gray-50 text-gray-600 hover:text-emerald-600 transition"
                >
                  <span className="text-lg shrink-0">
                    <LogoutIcon />
                  </span>

                  <span className="leading-tight">
                    {t("dashboardMenu.logout", "Logout")}
                  </span>
                </button>
              </div>
            </div>

            {/* Page Content */}
            <div className="w-full bg-white p-4 sm:p-5 lg:p-8 rounded-md overflow-hidden">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default User;